
<template>
  <div class="col-md-12">
    <div v-if="currentUser">
      <div class="card card-container">
        <img
          id="profile-img"
          src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
          class="profile-img-card"
        />
        <h3>Innlogget med Vipps</h3>
        <form name="form" @submit.prevent="handleLogin">
          <div class="form-group">
            <div>{{ currentUser.vippsuser.phone_number }}</div>
            <div>{{ currentUser.vippsuser.name }}</div>
          </div>
        </form>
      </div>
    </div> 
  </div>
</template>

<script>
import VippsUser from '../models/vippsuser';

export default {
  name: 'LoginLoggedin',
  data() {
    return {
      code: '',
      scope: '',
      state: '',
      vippsuser: new VippsUser('', '', '', '', ''),
      loading: false,
      message: ''
    };
  },
  computed: {
    currentUser() {
      // console.log("currentUser");
      // console.log(this.$store.state.auth.user);
      return this.$store.state.auth.user;
    },
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  created() {
  },
  methods: {
  }
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
</style>